import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import HeaderComponent from '../common/headerEdit.component';

const styles = theme => ({
  contentWrapper: {
    margin: (theme.spacing.unit * 2),
  },
});

const MainPageComponent = ({ children, classes, fileName, tabs, currentTab, changeTab, sessionId }) => (
  <React.Fragment>
    <HeaderComponent
    fileName={fileName}
    tabs={tabs}
    currentTab={currentTab}
    changeTab={changeTab}
    sessionId={sessionId}

    />
    <div className={classes.contentWrapper}>
      {children}
    </div>
  </React.Fragment>
);

MainPageComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  fileName: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  currentTab: PropTypes.number.isRequired,
  changeTab: PropTypes.func.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(MainPageComponent);
